// Feedback HTTP slice — `sendFeedbackReport` through the command bus.

import { Result } from "@bilda/utils";
import type { FeedbackPorts } from "../ports/feedback.js";
import { command } from "./shared.js";

export const feedbackHttp: FeedbackPorts = {
    sendFeedbackReport: async (input) => {
        const r = await command("sendFeedbackReport", input);
        return Result.isErr(r) ? r : Result.ok(undefined);
    },
};
